import { CustomerVehicleActionsComponent } from './customer.vehicle.actions.component';

export function CustomerVehiclesCtrl (
  $scope,
  $state,
  $translate,
  messages,
  sessionObjAPI,
  tableApi,
  workshopAPI,
  VVGarage
) {
  $scope.company              = sessionObjAPI.company();
  $scope.session              = sessionObjAPI.base();
  $scope.showCustomerVehicles = !!$scope.vehicles.length;
  $scope.tableCacheKey        = 'customerVehicles';
  $scope.VVGarage             = new VVGarage($scope.customer);

  if ($scope.company.company_variable_fields.plate_number_name) {
    $scope.regoLabel = $scope.company.company_variable_fields.plate_number_name;
  }
  else {
    $scope.regoLabel = sessionObjAPI.countrySettings().rego_label;
  };

  if ($scope.company.company_variable_fields.fleet_code_name) {
    $scope.fleetCodeLabel = $scope.company.company_variable_fields.fleet_code_name;
  }
  else {
    $scope.fleetCodeLabel = $translate.instant('VEHICLE_SPACE.FLEET_CODE');
  };

  $scope.columns = [
    {
      field : 'plate_number',
      header: {
        text: $scope.regoLabel,
      },
      classes: 'all-caps'
    },
    {
      field : 'make',
      header: {
        text: $translate.instant('VEHICLE_SPACE.MAKE')
      }
    },
    {
      field : 'model',
      header: {
        text: $translate.instant('VEHICLE_SPACE.MODEL')
      }
    },
    {
      field : 'model_code',
      header: {
        text: $translate.instant('VEHICLE_SPACE.MODEL_CODE')
      }
    },
    {
      field : 'model_series',
      header: {
        text: $translate.instant('VEHICLE_SPACE.MODEL_SERIES')
      }
    },
    {
      classes: 'text-center',
      field  : 'archived',
      header : {
        classes: 'text-center',
        text   : $translate.instant('GENERAL_SPACE.FIELD.STATUS')
      },
      isHtml: true,
      pipe  : 'archived',
    },
    {
      component: {
        bindings: {
          outputs: {
            onAddVVGarageClick   : vehicle => $scope.addVehicleToVVGarageCustomer(vehicle),
            onRemoveVVGarageClick: vehicle => $scope.addVehicleToVVGarageCustomer(vehicle),
            onEditClick          : vehicle => $state.go('app.vehicle', {
              customer_id: vehicle.customer_id,
              id         : vehicle.id
            }),
            onEventClick: vehicle => $state.go('app.event', {
              customer_id: vehicle.customer_id,
              vehicle_id : vehicle.id
            }),
            onInvoiceClick: vehicle => $state.go('app.invoice', {
              customer_id: vehicle.customer_id,
              vehicle_id : vehicle.id
            })
          }
        },
        enabled: true,
        factory: CustomerVehicleActionsComponent,
      },
      sortable: false
    }
  ];

  if ($scope.company.company_settings.show_fleet_code) {
    $scope.columns.splice($scope.columns.length - 1, 0, {
      field : 'fleet_code',
      header: {
        text: $scope.fleetCodeLabel
      }
    });
  }

  $scope.tableSettings = {
    cache: {
      enabled: true,
      key    : $scope.tableCacheKey
    },
    columns: $scope.columns,
    empty  : {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_VEHICLES_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : tableApi.getCachedPaging($scope.tableCacheKey).pageSize || 5,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/customers/vehicle_count/' + $scope.customer.id)
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: tableApi.setSortingFromCache($scope.tableCacheKey, {
      direction: 'asc',
      field    : 'plate_number'
    })
  };

  $scope.getVehicles = ( params ) => {
    return workshopAPI.get('/customers/vehicle_list', [
      $scope.customer.id,
      params.offset,
      params.pageSize,
      params.field,
      params.direction
    ]).then(vehicles => {
      $scope.vehicles = vehicles;

      return vehicles;
    });
  };

  $scope.onRowDoubleClick = function (event) {
    $state.go('app.vehicle', {
      customer_id: $scope.customer.id,
      id         : event.row.id
    });
  };

  $scope.addVehicleToVVGarageCustomer = function(vehicle) {
    $scope.VVGarage.add_vehicle_to_customer(vehicle).then(() => {
      messages.show($translate.instant('VV_GARAGE_SPACE.VEHICLE_ADDED_TO_CUSTOMER'), 'success');

      $state.reload();
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.removeVehicleFromVVGarageCustomer = function(vehicle) {
    $scope.VVGarage.delete_customer_vehicle(vehicle).then(() => {
      messages.show($translate.instant('VV_GARAGE_SPACE.VEHICLE_REMOVED_FROM_CUSTOMER'), 'success');

      $state.reload();
    }).catch(err => {
      messages.error(err);
    });
  };
}
